<template>
	<header class="header">
		<div v-if="isLogin" style="margin-right: 45px; display: flex; justify-content: center; align-items: center;">
			<img class="logo" v-if="isLogImg" :src="ErrorImzxc" alt @click="onClickLogo" />
			<page-header v-if="isLogImg" :levels="breadLevels" style="margin-left: 40px;" />
		</div>
		<template v-if="isLogin">
			<div style="margin-right: 45px; display: flex; justify-content: center; align-items: center;">
				<el-popover v-model="$store.state.job.isDot">
					<div _top="100px" _w="336px" _bg="white" _p="9px">
						<!-- tab切换 -->
						<div _flex="~" _w="100%" _cursor="pointer">
							<div
								_h="33px"
								_flex="~ items-center justify-center"
								:style="{
									flex: 1,
									borderRadius: '8px 8px 0px 0px',
									background: $store.state.job.action == '导入' ? 'rgba(134,132,132,0.25)' : '#FFFFFF',
									color: $store.state.job.action == '导入' ? '#242424' : '#A5A5A5'
								}"
								@click="$store.state.job.action = '导入'"
							>
								导入
							</div>
							<div
								_h="33px"
								_flex="~ items-center justify-center"
								:style="{
									flex: 1,
									borderRadius: '8px 8px 0px 0px',
									background: $store.state.job.action == '导出' ? 'rgba(134,132,132,0.25)' : '#FFFFFF',
									color: $store.state.job.action == '导出' ? '#242424' : '#A5A5A5'
								}"
								@click="$store.state.job.action = '导出'"
							>
								数据生成
							</div>
						</div>
						<div _pos="relative" _h="500px" _overflow="x-hidden">
							<!-- 导入 -->
							<div
								_h="500px"
								:class="$store.state.job.action == '导入' ? 'slide-fade-enter' : 'slide-fade-leave'"
								style="border-radius: '0 0 8px 8px';"
								_overflow="y-auto x-hidden"
							>
								<div v-if="$store.state.job.import?.length > 0">
                  <div
										_border="1px solid [#72BC8D] rounded-[4px]"
										_m="t-5px"
										_flex="~ justify-between items-center"
										_p="x-10px y-12px"
										:style="{ background: '#EEFFF5' }"
                    v-if="$store.state.job.isShowTip"
									>
                    <i
											_cursor="pointer"
											class="el-icon-warning"
											style="font-size: 20px;color:#72BC8D"
											_m="l-5px r-14px"
										/>
                    <span _flex="1" _text="16px">上传成功请刷新浏览器</span>
                    <i
											_cursor="pointer"
											class="el-icon-close"
											style="font-size: 20px;color:#72BC8D"
											_m="l-15px"
                      @click="visibleMisson"
										/>
                  </div>
									<div
										v-for="(item, index) in $store.state.job.import"
										:key="item?.job_id"
										_border="1px solid [#ECECEC] rounded-[4px]"
										_m="t-5px"
										_flex="~ justify-between items-center"
										_p="x-10px y-12px"
										:style="{ background: item.status == 'error' ? 'rgba(134,132,132,0.25)' : 'white' }"
									>
										<div _flex="1">
											<span _flex="~ items-center">
												<img :src="require(`@/assets/image/${item.type}.png`)" width="30px" />
												<div _m="l-10px" style="width: 100%;">
													<div _text="[#242424] 18px">{{ item.name }}</div>
													<div _m="t-10px" _flex="~ justify-between" _w="100%">
														<span _text="[#9E9E9E] 16px">{{ item.created_at }}</span>
														<span _text="[#DC4848] 16px" v-if="item.status == 'error'">导入失败</span>
													</div>
												</div>
											</span>
											<div
												_flex="~ justify-between items-center"
												_p="t-10px"
												_m="t-10px"
												style="border-top: 2px #e6e6e6 solid;"
												v-if="item.status == 'progress'"
											>
												<div _text="[#707070] 14px" _m="r-10px" v-if="item.size">{{ '共' + item.size }}</div>
												<el-progress
													:class="item.progress != 100 && 'progressBar'"
													:status="item.status == 'error' ? 'exception' : 'success'"
													:percentage="item.progress"
													:stroke-width="10"
													:show-text="false"
													_flex="1"
												></el-progress>
												<div _text="[#707070] 14px" _m="l-10px" _cursor="pointer">{{ item.progress }}%</div>
											</div>
										</div>
										<i
											_cursor="pointer"
											class="el-icon-circle-close"
											style="font-size: 20px;"
											_m="l-15px"
											v-if="item.status == 'completed' || item.status == 'error'"
											@click="stopMission(item, index, 'import')"
										/>
									</div>
								</div>
								<el-empty v-else description="暂无任务"></el-empty>
							</div>
							<!-- 导出 -->
							<div
								_h="500px"
								:class="$store.state.job.action == '导出' ? 'slide-fade-enter' : 'slide-fade-leave'"
								style="border-radius: '0 0 8px 8px';"
								_overflow="y-auto x-hidden"
							>
								<div v-if="$store.state.job.export?.length > 0">
									<div
										v-for="(item, index) in $store.state.job.export"
										:key="item?.job_id"
										_border="1px solid [#ECECEC] rounded-[4px]"
										_m="t-5px"
										_flex="~ justify-between items-center"
										_p="x-10px y-12px"
										:style="{ background: item.status == 'error' ? 'rgba(134,132,132,0.25)' : 'white' }"
									>
										<div _flex="1">
											<span _flex="~ items-center">
												<img :src="require(`@/assets/image/${item.type}.png`)" width="30px" />
												<div _m="l-10px" style="width: 100%;">
													<div _text="[#242424] 14px">{{ item.name }}</div>
													<div _m="t-10px" _w="100%">
														<span _text="[#9E9E9E] 14px">{{ item.created_at }}</span>
														<!-- <span _text="[#DC4848] 14px"
														v-if="item.status == 'error'">导出失败</span> -->
														<!-- <span _text="[#DC4848] 16px" v-if="item.stop">任务中止中...</span> -->
													</div>
													<div _m="t-5px">
														<span _text="[#DC4848] 12px" v-if="item.status == 'error'">导出失败</span>
													</div>
												</div>
											</span>
											<div
												_flex="~ justify-between items-center"
												_p="t-10px"
												_m="t-10px"
												style="border-top: 2px #e6e6e6 solid;"
												v-if="item.status == 'progress'"
											>
												<div _text="[#707070] 14px" _m="r-10px"></div>
												<el-progress
													:class="item.progress != 100 && 'progressBar'"
													:status="item.status == 'error' ? 'exception' : 'success'"
													:percentage="item.progress"
													:stroke-width="10"
													:show-text="false"
													_flex="1"
												></el-progress>
												<div _text="[#707070] 14px" _m="l-10px" _cursor="pointer">{{ item.progress }}%</div>
											</div>
										</div>
										<i
											_cursor="pointer"
											class="el-icon-download"
											style="font-size: 22px;"
											_m="l-15px"
											v-if="item.status == 'completed'"
											@click="downMisson(item)"
										/>
										<i
											_cursor="pointer"
											class="el-icon-download"
											style="font-size: 22px; display: block; opacity: 0;"
											_m="l-15px"
											v-else
										/>
										<i
											_cursor="pointer"
											class="el-icon-circle-close"
											style="font-size: 22px;"
											_m="l-15px"
											@click="stopMission(item, index, 'export')"
										/>
										<!-- <i _cursor="pointer" class="el-icon-circle-close" _m="l-15px" v-if="item.status != 'error'" @click="stopMission(item, index, 'export')"/> -->
									</div>
								</div>
								<el-empty v-else description="暂无任务"></el-empty>
							</div>
						</div>
					</div>
					<div slot="reference" _m="!r-10px">
						<el-badge v-if="$store.state.job.num > 0" :value="$store.state.job.num">
							<el-button size="small"
								><img :src="require('@/assets/image/job.png')" _w="13px" _m="r-5px" />任务列表</el-button
							>
						</el-badge>
						<el-button v-else size="small"
							><img :src="require('@/assets/image/job.png')" _w="13px" _m="r-5px" />任务列表</el-button
						>
					</div>
				</el-popover>
				<span class="avatar2">
					<img v-if="userInfo.avatar != null" :src="userInfo.avatar.url" />
					<img v-else src="https://file.xinhuomy.com/default.png" />
				</span>
				<el-dropdown
					size="small"
					popper-class="operateDropOption"
					trigger="click"
					@command="commandClick"
					style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; cursor: pointer;"
				>
					<span
						v-for="(label, idx) in accountLabels"
						:key="idx"
						:style="idx === 0 ? 'margin-bottom:10px' : null"
						class="el-dropdown-link"
					>
						{{ label }}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>

					<el-dropdown-menu slot="dropdown" style="width: 100px;">
						<el-dropdown-item command="personClick">个人中心</el-dropdown-item>
						<el-dropdown-item command="logoutClick">登出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</template>
	</header>
</template>
<script>
const ErrorImzxc = require('@/assets/test_client/MainLgo.png')
import { exportMDF } from '@/utils/job.js'
import { isElectron } from '@/utils/env.js'
export default {
	data() {
		return {
			ErrorImzxc,
			breadLevels: [],
			matched: null,
		}
	},
	watch: {
		$route() {
			this.$nextTick(function () {
				if (this.$store.state.user.userInfo != null) {
					this.refreshBasicBreadcrum()
				}
			})
		},
	},
	computed: {
		isLogin() {
			return this.$store.state.user.userInfo != null
		},
		isLogImg() {
			let routPath = this.$route.path
			return routPath != '/'
		},
		userInfo() {
			return this.$store.state.user.userInfo || {}
		},

		accountLabels() {
			switch (this.$store.state.user.userInfo.type) {
				case this.$api.account.types.TEACHER.value:
					if (this.userInfo.teachers == null) {
						return ['教师']
					} else {
						return [this.userInfo.realname + (this.userInfo.teachers.is_supervisor ? '学科长' : ' - 教师')]
					}
				case this.$api.account.types.SCHOOL_ADMIN.value:
					if (this.userInfo.school_admin == null) {
						return ['学校管理']
					} else {
						return [this.userInfo.realname + ' - 学校管理']
					}
				case this.$api.account.types.PLATFORM_ADMIN.value:
					// if (this.userInfo.platform_admin == null) {
					// 	return ['系统平台管理']
					// } else {
					return [this.userInfo.realname]
				// }
				case this.$api.account.types.RESEARCH.value:
					return [this.userInfo.realname + ' - 教研']
				case this.$api.account.types.OTHER.value:
					try {
						let display_name = this.userInfo?.roles[0].display_name
						return [display_name ? this.userInfo.realname + ' - ' + display_name : '访客']
					} catch (err) {
						return [this.userInfo.realname + '访客']
					}
			}
			return []
		}
	},
	methods: {
    visibleMisson() {
      this.$store.commit('isImportTip')
    },
		restMisson(item) {
			item.stop = false
			item.progress = 0
			item.status = 'progress'
			exportMDF(this, item)
		},
		downMisson(item, index, type) {
			const a = document.createElement('a')
			a.setAttribute('href', item.url)
			// 处理electron环境下会新创建一个窗口的问题
			if (isElectron == false) {
				a.setAttribute('target', '_blank')
			}
			a.setAttribute('download', item.name)
			a.click()
			console.log('___A___', a)
			document.body.removeChild(a)
		},
		async stopMission(item, index, type) {
			item.stop = true
			if (item.status == 'progress') {
				this.$store.state.job.num -= 1
			}
			window.localStorage.setItem(
				`job_${this.$store.state.user.userInfo.id}`,
				JSON.stringify({ ...this.$store.state.job })
			)
			if (item.status == 'progress') {
				const loading = this.$loading({
					lock: true,
					text: '正在中止任务，请稍等~',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})
				await new Promise(resolve => setTimeout(resolve, 2000))
				loading.close()
				this.$store.state.job[type].splice(index, 1)
			} else {
				this.$store.state.job[type].splice(index, 1)
			}
			window.localStorage.setItem(
				`job_${this.$store.state.user.userInfo.id}`,
				JSON.stringify({ ...this.$store.state.job })
			)
		},
		handleCommand(command) {
			this.$message('click on item ' + command)
		},
		onClickLogo() {
			this.$store.commit('isCollapseChange')
		},
		getQuery(query) {
			if (typeof query === 'object') {
				return query
			}
			if (typeof query === 'function') {
				return query()
			}
		},
		refreshBasicBreadcrum() {
			let activedMenu = this.getActivedMenu(this.$store.state?.menu)
			// 不需要理会
			if (this.nonBlockPage) return

			// 没有当选中 tab 信息
			if (!activedMenu) return

			// 一样的，不用更新
			if (this.breadLevels.length > 0 && activedMenu.name == this.breadLevels[0].name) {
				return
			}
			this.breadLevels = []
			this.breadLevels.push(activedMenu)
		},
		getActivedMenu(menu) {
			if (menu != null && this.$route.path != '/') {
				let rootEntry = menu.find(el => {
					if (el.contextedTo) {
						return (
							el.contextedTo.target == this.$route.meta.entry_menu && el.contextedTo.context == this.$route.meta.context
						)
					}
					// 处理二级菜单
					if (el.secondMenus) {
						let target = el.secondMenus.filter(el2 => {
							return el2.to == this.$route.meta.entry_menu
						})
						return target[0]
					}
					return el.to == this.$route.meta.entry_menu
				})

				if (rootEntry) {
					if (!rootEntry.secondMenus) {
						return {
							name: rootEntry.name,
							to: {
								name: rootEntry.to,
								query: this.getQuery(rootEntry.query),
								sbid: rootEntry.sbid
							}
						}
					} else {
						// 处理二级菜单
						let target = rootEntry.secondMenus.filter(el => {
							if (rootEntry.subjects) return el.sbid == this.$route.params.sbid
							else return el.to == this.$route.meta.entry_menu
						})
						return {
							name: target[0].name,
							to: {
								name: target[0].to,
								query: this.getQuery(target[0].query),
								sbid: target[0].sbid
							}
						}
					}
				} else {
					return null
				}
			}
		},
		goWorkBench() {
			switch (this.$store.state.user.userInfo.type) {
				case this.$api.account.types.TEACHER.value:
					if (this.$route.path != '/workbench/classgrade_mgn') this.$router.push('/workbench/classgrade_mgn')
					break
				case this.$api.account.types.SCHOOL_ADMIN.value:
					if (this.$route.path != '/workbench/classgrade_mgn') this.$router.push('/workbench/classgrade_mgn')
					break
				case this.$api.account.types.PLATFORM_ADMIN.value:
					if (this.$route.path != '/workbench') this.$router.push('/workbench')
					break
				default:
					if (this.$route.path != '/workbench') this.$router.push('/workbench')
			}
		},
		commandClick(event) {
			this[event]()
		},
		personClick() {
			// this.editPersonVisible = true
			this.$router.push({
				name: 'person'
			})
		},
		async logoutClick() {
			// window.localStorage.removeItem('tokenInfo')
			// window.localStorage.removeItem('accountInfo')
			// window.localStorage.removeItem('vuex.saved')
			// window.localStorage.removeItem('vuex.menu')
			// window.localStorage.removeItem('passTip')
			let url = window.location
			window.location.replace(`${url.origin}${url.pathname}#/oneLogin`)
		}
	},
}
</script>

<style lang="scss">
@import '@/styles/settings.scss';

.avatar2 {
	display: inline-flex;
	overflow: hidden;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: 1px solid #f0f0f0;
	margin-bottom: 1px;
	margin-right: 11px;

	img {
		object-fit: cover;
		width: 100%;
	}
}

.header {
	background: #fff;
	height: 56px;
	position: sticky;
	// position: fixed;
	top: 0;
	z-index: 9;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100vw;
	z-index: 999;

	.logo {
		width: 160px;
		padding-left: 15px;
	}

	.logout-btn {
		transition: all 0.3s;
		font-size: 14px;
		border: 1px solid $--color-primary;
		box-sizing: border-box;
		border-radius: 4px;
		width: 60px;
		height: 28px;
		line-height: 28px;
		color: $--color-primary;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		margin-right: 25px;

		span {
			margin-left: 4px;
		}

		&:hover {
			color: white;
			background: $--color-primary;
		}
	}
}
</style>

<style lang="scss" scoped>
/deep/ .el-button {
	span {
		display: flex;
	}
}

.progressBar {
	/deep/ .el-progress-bar__inner::before {
		content: '';
		display: block;
		width: 40px;
		width: 30px;
		height: inherit;
		background-image: linear-gradient(-45deg, transparent, rgba(255, 255, 255, 0.8), transparent);
		animation: shadow 2s infinite;
	}
}

@keyframes shadow {
	0% {
		transform: translateX(0);
	}

	100% {
		transform: translateX(200px);
	}
}

.slide-fade-enter {
	position: absolute;
	width: 100%;
	transition: all 0.3s ease;
	transform: translateX(0);
	opacity: 1;
}

.slide-fade-leave {
	position: absolute;
	width: 100%;
	transition: all 0.3s ease;
	transform: translateX(100%);
	opacity: 0;
}
</style>
